import { AssetManagerModal } from 'modules/assetManager/components/AssetManagerModal';
import { useEffect } from 'react';
import { useSmsSmartOptInContext } from './contexts/SmsSmartOptInContext';
import { SmsSmartOptInDetails } from './SmsSmartOptInDetails';
import { SmsSmartOptInForm } from './SmsSmartOptInForm';
import { SmsSmartOptInListEntry } from './SmsSmartOptInListEntry';

export const SmsSmartOptInModal = () => {
  const { assets, isEditing, setIsEditing, setIsModalOpen } = useSmsSmartOptInContext();

  useEffect(() => {
    // default to editing view if no sms opt-in links have been created
    setIsEditing(assets.length === 0);
  }, []);

  return (
    <AssetManagerModal
      id="sms-smart-opt-in-modal"
      AssetForm={isEditing ? SmsSmartOptInForm : SmsSmartOptInDetails}
      ListEntry={SmsSmartOptInListEntry}
      onClose={() => setIsModalOpen(false)}
    />
  );
};
